import { VehicleForm } from './view';

export { default as VehicleFormSaga } from './saga';

export default VehicleForm;
